webpackJsonp([43983713763584],{

/***/ 864:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(10);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(11);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _mentor = __webpack_require__(688);
	
	var _mentor2 = _interopRequireDefault(_mentor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Mentor = function (_React$Component) {
	    _inherits(Mentor, _React$Component);
	
	    function Mentor() {
	        _classCallCheck(this, Mentor);
	
	        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	    }
	
	    Mentor.prototype.handleSubmit = function handleSubmit(event) {
	        alert("Form submitted. Thank you for your interest in DeltaHacks!");
	        // setTimeout(document.getElementById("mentor-signup-form").reset(), 5000);
	    };
	
	    Mentor.prototype.render = function render() {
	        return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	                _reactHelmet2.default,
	                null,
	                _react2.default.createElement(
	                    'title',
	                    null,
	                    'Be A Mentor - DeltaHacks V'
	                ),
	                _react2.default.createElement('meta', { name: 'description', content: 'Sign up to be a mentor here!' })
	            ),
	            _react2.default.createElement(
	                'div',
	                { id: 'main', className: 'gradient' },
	                _react2.default.createElement(
	                    'section',
	                    { id: 'description' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'inner' },
	                        _react2.default.createElement(
	                            'h4',
	                            null,
	                            'How can you help?'
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'We\'re looking for mentors to help fill the following roles:'
	                        ),
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'table-wrapper' },
	                            _react2.default.createElement(
	                                'table',
	                                null,
	                                _react2.default.createElement(
	                                    'thead',
	                                    null,
	                                    _react2.default.createElement(
	                                        'tr',
	                                        null,
	                                        _react2.default.createElement(
	                                            'th',
	                                            null,
	                                            'Role'
	                                        ),
	                                        _react2.default.createElement(
	                                            'th',
	                                            null,
	                                            'Description'
	                                        ),
	                                        _react2.default.createElement(
	                                            'th',
	                                            null,
	                                            'Time Commitment'
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'tbody',
	                                    null,
	                                    _react2.default.createElement(
	                                        'tr',
	                                        null,
	                                        _react2.default.createElement(
	                                            'td',
	                                            null,
	                                            'Technical Mentor'
	                                        ),
	                                        _react2.default.createElement(
	                                            'td',
	                                            null,
	                                            'Provide guidance for participants using your expertise.'
	                                        ),
	                                        _react2.default.createElement(
	                                            'td',
	                                            null,
	                                            'At least 2 hours anytime between 12:00pm, January 26th and 12:00pm, January 27th.'
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'tr',
	                                        null,
	                                        _react2.default.createElement(
	                                            'td',
	                                            null,
	                                            'Challenger Mentor'
	                                        ),
	                                        _react2.default.createElement(
	                                            'td',
	                                            null,
	                                            'Inspire attendees to come up with innovative ideas. Pitch a project idea to teams during an Idea Generation Session on January 26th from 12PM to 3PM. Answer any questions the team may have about your idea.'
	                                        ),
	                                        _react2.default.createElement(
	                                            'td',
	                                            null,
	                                            '12pm - 3pm on Saturday, January 26th. Remain available, either in-person or remotely until noon on January 27th.'
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'tr',
	                                        null,
	                                        _react2.default.createElement(
	                                            'td',
	                                            null,
	                                            'Judge'
	                                        ),
	                                        _react2.default.createElement(
	                                            'td',
	                                            null,
	                                            'Critically analyze and evaluate finished projects at the Project Expo.'
	                                        ),
	                                        _react2.default.createElement(
	                                            'td',
	                                            null,
	                                            '3 hours on Sunday, January 27th.'
	                                        )
	                                    )
	                                )
	                            )
	                        ),
	                        _react2.default.createElement(
	                            'p',
	                            null,
	                            'If you think you could help, please fill the form below! If you have questions, email us at ',
	                            _react2.default.createElement(
	                                'a',
	                                { href: 'mailto:relations@deltahacks.com' },
	                                'relations@deltahacks.com'
	                            ),
	                            ' and we\'d be happy to answer them!'
	                        )
	                    )
	                ),
	                _react2.default.createElement(
	                    'section',
	                    { id: 'signup' },
	                    _react2.default.createElement(
	                        'section',
	                        null,
	                        _react2.default.createElement('iframe', { width: '0', height: '0', name: 'hidden-form' }),
	                        _react2.default.createElement(
	                            'form',
	                            { id: 'mentor-signup-form', onSubmit: this.handleSubmit, method: 'post', target: 'hidden-form', action: 'https://script.google.com/a/mcmaster.ca/macros/s/AKfycbzzqgracu41ephczSIgCrJrXR_gTx2d57B-914Sy3Jk7ae_-Po/exec' },
	                            _react2.default.createElement('input', { type: 'hidden', name: 'bot-field' }),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'row uniform' },
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: '6u 12u(small)' },
	                                    _react2.default.createElement(
	                                        'label',
	                                        null,
	                                        'Name *',
	                                        _react2.default.createElement('input', { type: 'text', name: 'name', placeholder: 'Name', required: true })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: '6u 12u(small)' },
	                                    _react2.default.createElement(
	                                        'label',
	                                        null,
	                                        'Email Address *',
	                                        _react2.default.createElement('input', { type: 'email', name: 'email', id: 'email', placeholder: 'Email', required: true })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: '6u 12u(small)' },
	                                    _react2.default.createElement(
	                                        'label',
	                                        null,
	                                        'Phone Number',
	                                        _react2.default.createElement('input', { type: 'tel', name: 'phone', id: 'phone', placeholder: '416-777-7777' })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: '6u 12u(small)' },
	                                    _react2.default.createElement(
	                                        'label',
	                                        null,
	                                        'Role *',
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'select-wrapper' },
	                                            _react2.default.createElement(
	                                                'select',
	                                                { name: 'type', id: 'type' },
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 'Technical' },
	                                                    'Technical Mentor'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 'Challenger' },
	                                                    'Challenger Mentor'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 'Judge' },
	                                                    'Judge'
	                                                )
	                                            )
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: '6u 12u(small)' },
	                                    _react2.default.createElement(
	                                        'label',
	                                        null,
	                                        'Expertise *',
	                                        _react2.default.createElement('input', { type: 'text', name: 'expertise', id: 'expertise', placeholder: 'Blockchain, VR, C++' })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: '6u 12u(small)' },
	                                    _react2.default.createElement(
	                                        'label',
	                                        null,
	                                        'Organization *',
	                                        _react2.default.createElement('input', { type: 'text', name: 'organization', id: 'organization', placeholder: 'McMaster University' })
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: '6u 12u(small)' },
	                                    _react2.default.createElement(
	                                        'label',
	                                        null,
	                                        'Dietary Restrictions *',
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'select-wrapper' },
	                                            _react2.default.createElement(
	                                                'select',
	                                                { name: 'diet', id: 'diet' },
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 'None' },
	                                                    'None'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 'Vegetarian' },
	                                                    'Vegetarian'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 'Vegan' },
	                                                    'Vegan'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 'Halal' },
	                                                    'Halal'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 'Gluten Free' },
	                                                    'Gluten Free'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 'Kosher' },
	                                                    'Kosher'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 'No Beef' },
	                                                    'No Beef'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 'Lactose Intolerant' },
	                                                    'Lactose Intolerant'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 'Food/Nut Allergy' },
	                                                    'Food/Nut Allergy'
	                                                )
	                                            )
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: '6u 12u(small)' },
	                                    _react2.default.createElement(
	                                        'label',
	                                        null,
	                                        'T-Shirt Size *',
	                                        _react2.default.createElement(
	                                            'div',
	                                            { className: 'select-wrapper' },
	                                            _react2.default.createElement(
	                                                'select',
	                                                { name: 'tshirt', id: 'tshirt' },
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 'Error' },
	                                                    'Select a size'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 'S' },
	                                                    'S'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 'M' },
	                                                    'M'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 'L' },
	                                                    'L'
	                                                ),
	                                                _react2.default.createElement(
	                                                    'option',
	                                                    { value: 'XL' },
	                                                    'XL'
	                                                )
	                                            )
	                                        )
	                                    )
	                                ),
	                                _react2.default.createElement(
	                                    'div',
	                                    { className: '12u' },
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: '12u 12u' },
	                                        _react2.default.createElement(
	                                            'label',
	                                            null,
	                                            'Why do you want to be a mentor? * (~300 char)',
	                                            _react2.default.createElement('textarea', { name: 'why', id: 'why', placeholder: 'I really enjoy helping people...', rows: '4', required: true })
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'div',
	                                        { className: '12u 12u(small)' },
	                                        _react2.default.createElement('input', { type: 'checkbox', id: 'code', name: 'code', required: true }),
	                                        _react2.default.createElement(
	                                            'label',
	                                            { htmlFor: 'code' },
	                                            'I agree to abide by the MLH Code of Conduct and the MLH Privacy Policy.'
	                                        )
	                                    ),
	                                    _react2.default.createElement(
	                                        'ul',
	                                        { className: 'actions' },
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            _react2.default.createElement('input', { type: 'submit', value: 'Sign up', className: 'special' })
	                                        ),
	                                        _react2.default.createElement(
	                                            'li',
	                                            null,
	                                            _react2.default.createElement('input', { type: 'reset', value: 'Reset' })
	                                        )
	                                    )
	                                )
	                            )
	                        )
	                    )
	                )
	            )
	        );
	    };
	
	    return Mentor;
	}(_react2.default.Component);
	
	exports.default = Mentor;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-mentor-js-c92e0facd23fa93a6c1f.js